module.exports = __webpack_public_path__ + "files/30f43e0159f7fb3d61c621e442f7dd10.svg";